import { useEffect } from 'react'
import { toast } from 'react-toastify'

const customId = 'form-error-id'

const FormError = ({ errors }) => {
  console.log('errors', errors)
  useEffect(() => {
    if (Object.keys(errors).length) {
      toast.error('Please correct all highlighted errors and try again.', {
        toastId: customId
      })
    }
  }, [errors])

  return null
}

export default FormError
